/* tslint:disable */
/* eslint-disable */
/**
 * BackOffice — Attributions par plateforme
 * Briques d\'un collaborateur par plateforme (override du compte, sémantique d\'override total avec repli sur le compte) et plafond délégable de la plateforme. Keyé par COLLABORATEUR (abpUserId) : un cabinet de N collaborateurs expose N lignes, et les collaborateurs d\'une corporate (sans ligne Courtier) sont adressables. Surface admin de l\'atelier des rôles + surface gouvernance du Portail Plateforme. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CabinetBriquesPlateformeDto } from './CabinetBriquesPlateformeDto';
import {
    CabinetBriquesPlateformeDtoFromJSON,
    CabinetBriquesPlateformeDtoFromJSONTyped,
    CabinetBriquesPlateformeDtoToJSON,
    CabinetBriquesPlateformeDtoToJSONTyped,
} from './CabinetBriquesPlateformeDto';

/**
 * 
 * @export
 * @interface GetCabinetsBriquesPlateformeResponse
 */
export interface GetCabinetsBriquesPlateformeResponse {
    /**
     * 
     * @type {number}
     * @memberof GetCabinetsBriquesPlateformeResponse
     */
    totalCount: number;
    /**
     * Plateforme en mode Administrée : l'admin pilote, la PM principale la représente sans la gérer — le badge de la liste s'adapte.
     * 
     * @type {boolean}
     * @memberof GetCabinetsBriquesPlateformeResponse
     */
    estAdministree: boolean;
    /**
     * 
     * @type {Array<CabinetBriquesPlateformeDto>}
     * @memberof GetCabinetsBriquesPlateformeResponse
     */
    items: Array<CabinetBriquesPlateformeDto>;
}

/**
 * Check if a given object implements the GetCabinetsBriquesPlateformeResponse interface.
 */
export function instanceOfGetCabinetsBriquesPlateformeResponse(value: object): value is GetCabinetsBriquesPlateformeResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('estAdministree' in value) || value['estAdministree'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetCabinetsBriquesPlateformeResponseFromJSON(json: any): GetCabinetsBriquesPlateformeResponse {
    return GetCabinetsBriquesPlateformeResponseFromJSONTyped(json, false);
}

export function GetCabinetsBriquesPlateformeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCabinetsBriquesPlateformeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'estAdministree': json['estAdministree'],
        'items': ((json['items'] as Array<any>).map(CabinetBriquesPlateformeDtoFromJSON)),
    };
}

export function GetCabinetsBriquesPlateformeResponseToJSON(json: any): GetCabinetsBriquesPlateformeResponse {
    return GetCabinetsBriquesPlateformeResponseToJSONTyped(json, false);
}

export function GetCabinetsBriquesPlateformeResponseToJSONTyped(value?: GetCabinetsBriquesPlateformeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'estAdministree': value['estAdministree'],
        'items': ((value['items'] as Array<any>).map(CabinetBriquesPlateformeDtoToJSON)),
    };
}

